import React, { useState } from 'react'
import { TextBlock } from '../../../components/1elements'

import GenericInPlacePickList from './GenericInPlacePickList'
const AddressSearch = ({ bucket, formikProps, editMode }) => {
  bucket.tempChanges.presaveProcessor = ({ countries, regions, cities }) => {
    const childlessCountries = countries.filter(
      c => !regions.some(r => r.countryCode === c.isoCode)
    )
    const childlessRegions = regions.filter(
      r => !cities.some(c => c.stateCode === r.isoCode)
    )
    const returnValue = []
    childlessCountries.forEach(c => {
      returnValue.push({ name: c.name, country: c.isoCode })
    })
    childlessRegions.forEach(r => {
      returnValue.push({
        name: r.name + ', ' + r.countryCode,
        region: r.isoCode,
        country: r.countryCode
      })
    })
    cities.forEach(c => {
      returnValue.push({
        name: c.name + ', ' + c.stateCode + ', ' + c.countryCode,
        city: c.name,
        region: c.stateCode,
        country: c.countryCode
      })
    })
    return returnValue
  }

  const [countries, setCountries] = useState(
    bucket.selection.filter(
      c => !c.countryCode && !c.stateCode && c.isoCode && c.name
    )
  )

  const [regions, setRegions] = useState(
    bucket.selection.filter(
      c => c.countryCode && c.isoCode && c.name && !c.stateCode
    )
  )
  const [cities, setCities] = useState(
    bucket.selection.filter(c => c.countryCode && c.stateCode && c.name)
  )

  const shouldDisableRegion = () => {
    return !countries.length
  }
  const shouldDisableCity = () => {
    const result = !countries.length || !regions.length
    console.log(result)
    return result
  }

  return (
    <>
      <TextBlock>
        <GenericInPlacePickList
          selection={countries}
          searchMoreCallback={bucket.searchCallback}
          pickerEntityDisplayName={'Country'}
          listPropertyName={'NOP'}
          deepSetSelection={newSelection => {
            bucket.tempChanges.data.countries = newSelection
            bucket.tempChanges.data.regions = regions
            bucket.tempChanges.data.cities = cities

            setCountries(newSelection)
          }}
          equalityEvaluator={(a, b) => a.isoCode === b.isoCode}
          formikProps={formikProps}
          disabled={!editMode}
        />
      </TextBlock>
      <TextBlock>
        <GenericInPlacePickList
          selection={regions}
          searchMoreCallback={keyword => {
            if (!countries.length) return []
            return bucket.searchCallback({ countries: countries }, keyword)
          }}
          pickerEntityDisplayName={'State/Province'}
          listPropertyName={'NOP'}
          deepSetSelection={newSelection => {
            bucket.tempChanges.data.regions = newSelection
            bucket.tempChanges.data.countries = countries
            bucket.tempChanges.data.cities = cities

            setRegions(newSelection)
          }}
          equalityEvaluator={(a, b) =>
            a.isoCode === b.isoCode && a.countryCode === b.countryCode
          }
          formikProps={formikProps}
          disabled={shouldDisableRegion()}
        />
      </TextBlock>
      <TextBlock>
        <GenericInPlacePickList
          selection={cities}
          searchMoreCallback={keyword => {
            if (!regions.length) return []
            return bucket.searchCallback({ states: regions }, keyword)
          }}
          pickerEntityDisplayName={'City'}
          listPropertyName={'NOP'}
          deepSetSelection={newSelection => {
            bucket.tempChanges.data.cities = newSelection
            bucket.tempChanges.data.countries = countries
            bucket.tempChanges.data.regions = regions

            setCities(newSelection)
          }}
          equalityEvaluator={(a, b) =>
            a.name === b.name &&
            a.countryCode === b.countryCode &&
            a.stateCode === b.stateCode
          }
          formikProps={formikProps}
          disabled={shouldDisableCity()}
        />
      </TextBlock>
    </>
  )
}

export default React.memo(AddressSearch)
